import { HeroSection } from "@admin/components/organisms/HeroSection";

// import { MyAccountant } from "./_components/MyAccountant";
import { AdminInfo } from "./components/AdminInfo";
import { CompanyInfo } from "./components/CompanyInfo";
// import { Accordion } from "@admin/components/molecules/Accordion";

export default function SettingsPage() {
  return (
    <>
      <HeroSection />
      <div className="grid md:grid-cols-2 gap-7.5">
        <div className="col-span-1 space-y-7.5">
          <AdminInfo />
        </div>
        <div className="col-span-1 space-y-7.5">
          <CompanyInfo />
        </div>
        <div>
          {/* <MyAccountant /> */}
          {/* <Accordion /> */}
        </div>
      </div>
    </>
  );
}
